<template>
  <section class="component--wrapper">
    <el-row>
      <el-col :xl="24">
        <h1>
          <b>Como podemos ajudar ?</b>
        </h1>
      </el-col>
    </el-row>
    <div class="cards--wrapper">
      <div
        v-for="reason in reasons"
        :key="reason.id"
        @click="handleActiveClass(reason)"
        class="card-item"
        shadow="hover"
        :class="{ cardItemActive: reason.selected }"
      >
        <p>{{ reason.text }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      reasons: [
        {
          id: 1,
          text: "Aumentar as vendas.",
          selected: false
        },
        {
          id: 2,
          text: "Facilitar a cobrança.",
          selected: false
        },
        {
          id: 3,
          text: "Controlar a inadimplência.",
          selected: false
        }
      ]
    };
  },
  methods: {
    handleActiveClass(reason) {
      this.reasons.map(item => (item.selected = false));
      this.emitUserAccountEvent(reason);
      return (reason.selected = true);
    },
    emitUserAccountEvent(reason) {
      this.$emit("canWeHelpQuestion", reason.text);
      this.$emit("userAccountEvent");
    }
  }
};
</script>

<style lang="scss" scoped>
.component--wrapper {
  margin: 1rem auto 0 auto;
  text-align: center;
  max-width: 700px;
}
.cards--wrapper {
  display: grid;
  @media screen and(max-width: 768px) {
    grid: auto / 1fr;
  }
  @media screen and(min-width: 769px) and (max-width: 991px) {
    grid: 1fr 1fr 1fr / 1fr 1fr 1fr;
  }
  grid: 1fr / 1fr 1fr 1fr;
  grid-gap: 10px;
  align-content: center;
  justify-content: center;
}
.card-item {
  @media screen and(min-width: 769px) {
    display: grid;
  }
  height: 100%;
  width: 100%;
  padding: 2rem 0.5rem;
  font-weight: bold;
  background-color: #ffffff;
  border-radius: 5px;
  border: 1px solid rgba(108, 115, 124, 0.3);
  cursor: pointer;
  transition: box-shadow 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  &:hover {
    box-shadow: 0 5px 5px rgba(0, 0, 0, 0.2);
  }
  p {
    color: $laranja;
    align-self: center;
    line-height: 100%;
  }
}
.cardItemActive {
  box-shadow: 0;
  border: 2px solid $laranja;
}
</style>
